// Avvio dell'app SPA Sensorial.
// Caratteri della tela D9 dentro l'app (solo alfabeto latino, pesi usati): niente Google, vanno anche senza rete.
import '@fontsource/raleway/latin-400.css';
import '@fontsource/raleway/latin-500.css';
import '@fontsource/raleway/latin-600.css';
import '@fontsource/raleway/latin-700.css';
import '@fontsource/cormorant-garamond/latin-600.css';
import '@fontsource/cormorant-garamond/latin-700.css';
import './stile.css';
import { collection, doc, writeBatch, serverTimestamp } from 'firebase/firestore';
import { avviaFirebase, utenteCollegato, modalitaProva } from './dati/firebase.js';
import { ascoltaDispositivo, togliMiaRichiesta } from './dati/accesso.js';
import { creaScatolaNera, ascoltaErroriPagina } from './logica/scatola-nera.js';
import { scegliLingua, linguaDelTelefono } from './i18n.js';
import { schermataAvvio, schermataErrore, schermataAttesa } from './ui/schermate.js';
import { schermataApp } from './ui/sezioni.js';

const SID = 'villa-carola';
const VERSIONE = typeof __VERSIONE__ !== 'undefined' ? __VERSIONE__ : 'sviluppo';

function leggiLingua() {
  try { return localStorage.getItem('spa.lingua'); } catch { return null; }
}

async function avvia() {
  scegliLingua(leggiLingua() || linguaDelTelefono());
  schermataAvvio();

  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    navigator.serviceWorker.register('./sw.js').catch(() => {});
  }

  const { db, auth } = avviaFirebase();
  let uid = null;
  // Scatola nera (S3): gli errori del telefono arrivano nel database, anche dopo ore senza rete.
  const scatola = creaScatolaNera({
    archivio: globalThis.localStorage,
    info: () => ({ versione: VERSIONE, pagina: location.hash || '/', inLinea: navigator.onLine, agente: navigator.userAgent.slice(0, 160) }),
    invia: async (lista) => {
      if (!uid) throw new Error('non ancora collegato');
      const b = writeBatch(db);
      for (const v of lista) {
        b.set(doc(collection(db, `strutture/${SID}/errori`)), { ...v, messaggio: String(v.messaggio).slice(0, 4000), da: uid, quando: serverTimestamp() });
      }
      await b.commit();
    },
  });
  ascoltaErroriPagina(scatola);

  try {
    const utente = await utenteCollegato(auth);
    uid = utente.uid;
  } catch (e) {
    scatola.registra(e, { dove: 'accesso' });
    schermataErrore(e, () => location.reload());
    return;
  }
  scatola.svuota();

  const ctx = { db, auth, sid: SID, uid, scatola, modalitaProva };
  let ferma = () => {};
  let ultimo = '';
  ascoltaDispositivo(ctx, (d) => {
    // Ridisegna solo quando cambia davvero qualcosa che conta (ruoli, attivo, nome, colonna).
    const chiave = JSON.stringify(d && [d.attivo, d.ruoli, d.nome, d.lingua, d.op]);
    if (chiave === ultimo) return;
    ultimo = chiave;
    ferma();
    if (!d) ferma = schermataAttesa(ctx, { inviata: false });
    else if (!d.attivo) ferma = schermataAttesa(ctx, { disattivo: true });
    else {
      if (d.lingua && !leggiLingua()) scegliLingua(d.lingua);
      togliMiaRichiesta(ctx).catch((e) => scatola.registra(e, { dove: 'togli-richiesta' }));
      ferma = schermataApp(ctx, d);
    }
  }, (e) => {
    scatola.registra(e, { dove: 'dispositivo' });
    schermataErrore(e, () => location.reload());
  });
}

avvia();
